import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=5a7b50e5"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=5a7b50e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports